module.exports = __webpack_public_path__ + "img/city_bgbuildings.b066a021.png";